/* eslint-disable camelcase */
import { SORT_ORDER, TFilterOptions } from '@evinced-private/ui-common';

import omit from 'lodash-es/omit';
import { CUSTOM_FIELDS_FILTER_PARAM_KEY } from 'src/apps/dashboard/constants/CustomFields';
import {
	MOBILE_APP_ID_FILTER_ID,
	MOBILE_PLATFORM_FILTER_ID
} from 'src/apps/dashboard/constants/MobileDashboard.constants';
import { IGetMfaSessionsParams } from 'src/apps/dashboard/types/MobileDashboardServiceTypes';
import { IFilterOptions } from 'src/common/helpers/DataFilterHelper';
import { QueryVariablesBuilder } from 'src/common/helpers/GQLRequestsHelper/QueryVariablesBuilder';
import {
	ConditionOperators,
	Mfa_Session_RunsSortFields,
	Mfa_Session_RunsSortOrder
} from 'src/common/types/graphql.generated';

import { MobileDashboardMfaSessionsQueryVariables } from '../MfaSessions.generated';

import { buildMobileRunFilters } from './mobileFilterVariableBuilder';

const DAYS_AMOUNT_FILTER_PARAM_KEY = 'daysAmountFilter';

const MOBILE_SESSION_FILTER_KEYS = [
	'dateRange',
	MOBILE_PLATFORM_FILTER_ID,
	MOBILE_APP_ID_FILTER_ID
];

const mfaSessionsSortFieldNamesMap: Record<string, Mfa_Session_RunsSortFields> = {
	name: Mfa_Session_RunsSortFields.SessionName,
	sessionName: Mfa_Session_RunsSortFields.SessionName,
	date: Mfa_Session_RunsSortFields.RunUpdatedAt,
	runTime: Mfa_Session_RunsSortFields.RunUpdatedAt,
	criticalIssues: Mfa_Session_RunsSortFields.CriticalIssues,
	totalIssues: Mfa_Session_RunsSortFields.TotalIssues,
	user: Mfa_Session_RunsSortFields.UserName,
	createdBy: Mfa_Session_RunsSortFields.UserName
};

const mfaSessionsSortOrderMap: Record<SORT_ORDER, Mfa_Session_RunsSortOrder> = {
	[SORT_ORDER.ASC]: Mfa_Session_RunsSortOrder.Ascending,
	[SORT_ORDER.DESC]: Mfa_Session_RunsSortOrder.Descending
};

export const buildMfaSessionsVariables = ({
	dateRange,
	pageSize,
	page,
	filterOptions,
	sort,
	labelsExcludedFromDashboard
}: IGetMfaSessionsParams): MobileDashboardMfaSessionsQueryVariables => {
	const variablesBuilder = new QueryVariablesBuilder<MobileDashboardMfaSessionsQueryVariables>({
		sortFieldsMap: mfaSessionsSortFieldNamesMap,
		sortOrderMap: mfaSessionsSortOrderMap
	});

	variablesBuilder.addPaginationParams(page, pageSize).addSortParam(sort);

	const customFieldOptions = omit(
		filterOptions ?? {},
		MOBILE_SESSION_FILTER_KEYS
	) as TFilterOptions;

	variablesBuilder.addTupleFilterParam(
		CUSTOM_FIELDS_FILTER_PARAM_KEY,
		customFieldOptions,
		ConditionOperators.All,
		true
	);

	variablesBuilder.addConditionParam(DAYS_AMOUNT_FILTER_PARAM_KEY, dateRange);

	if (labelsExcludedFromDashboard && Object.keys(labelsExcludedFromDashboard).length > 0) {
		variablesBuilder.addNeTupleFilterParam(
			'customFieldsFilterExcludes' as keyof MobileDashboardMfaSessionsQueryVariables,
			labelsExcludedFromDashboard
		);
	}

	const mobileRunFilters = buildMobileRunFilters(filterOptions as IFilterOptions);

	return {
		...variablesBuilder.getVariables(),
		...mobileRunFilters
	};
};
